var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrabajadorOscuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 17.3989V22.9999C39 27.4179 35.418 30.9999 31 30.9999C26.582 30.9999 23 27.4179 23 22.9999V17.3989",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14C42 7.923 37.073 2.998 30.996 3C24.827 3.002 20 8.275 20 14.395V17C20 17.681 20.659 18.164 21.307 17.952C24.056 17.052 27 16 31 16C35 16 37.944 17.052 40.693 17.951C41.341 18.163 42 17.681 42 17V14Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12H31",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 12H35",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.562 33.6401C34.779 35.0311 33.031 36.0001 31 36.0001C28.929 36.0001 27.118 34.9511 26.359 33.5161",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36V59",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 40.5,
    width: 1,
    height: 1,
    strokeWidth: 1,
    stroke: "#101820"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 44.5,
    width: 1,
    height: 1,
    strokeWidth: 1,
    stroke: "#101820"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 48.5,
    width: 1,
    height: 1,
    strokeWidth: 1,
    stroke: "#101820"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 52.5,
    width: 1,
    height: 1,
    strokeWidth: 1,
    stroke: "#101820"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 56.5,
    width: 1,
    height: 1,
    strokeWidth: 1,
    stroke: "#101820"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.798 35.2881L48.36 20.0021L48.002 18.9961",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.36 20.0019L48.002 18.9959L47.06 16.3489C46.811 15.6599 47.358 14.9439 48.089 15.0029L57.073 15.9999C57.88 16.0659 58.283 17.0079 57.774 17.6369L50.315 25.4969",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19 59V47.857C19 45.458 18.244 43.119 16.84 41.174L2.66801 21.542C2.09501 20.749 1.83301 19.716 2.11301 18.609C2.43101 17.35 3.47901 16.345 4.74901 16.079C6.22001 15.771 7.56301 16.394 8.33201 17.458L19.74 33.256C20.531 34.351 21.8 35 23.151 35C24.871 35 26.419 33.953 27.058 32.355L27.857 30.358",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.143 30.3579L35.157 32.8929C35.638 34.0949 36.713 34.9509 37.99 35.1639C40.455 35.5759 42.749 36.7469 44.538 38.5389L48.908 42.9149",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43 59V47L47.025 50.975C47.659 51.608 48.534 52 49.5 52C50.74 52 51.824 51.351 52.445 50.377L59.448 39.372C59.793 38.83 60 38.19 60 37.5C60 35.567 58.433 34 56.5 34C55.257 34 54.173 34.652 53.552 35.628L47.701 44.81",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrabajadorOscuro);
export default __webpack_public_path__ + "static/media/trabajadorOscuro.026011dc2da5e688b251a36529f10c84.svg";
export { ForwardRef as ReactComponent };